import { render } from "./TexturesView.vue?vue&type=template&id=5f57b095"
import script from "./TexturesView.vue?vue&type=script&lang=js"
export * from "./TexturesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__